export function ensureArray<T>(value: unknown): T[] {
  if (Array.isArray(value)) {
    return value as T[]
  }
  return []
}

export function sortByLocale<T>(
  items: T[],
  selector: (item: T) => string = (value) => String(value),
): T[] {
  return [...items].sort((a, b) =>
    selector(a).localeCompare(selector(b), 'pt-BR', { sensitivity: 'base' }),
  )
}


